import { ApiClient, ApiOrg, MessagesClient } from "lib/api";
import { JwtUser } from "utils";

export type Action =
  | {
      type: "LOGIN";
      user: JwtUser;
      client: ApiClient;
      org: ApiOrg;
      messages: MessagesClient;
    }
  | { type: "LOGOUT" }
  | { type: "UPDATE_ORG"; org: ApiOrg };

export function actionLogin(
  user: JwtUser,
  client: ApiClient,
  org: ApiOrg,
  messages: MessagesClient
): Action {
  return { type: "LOGIN", user, client, org, messages };
}

export function actionLogout(): Action {
  return { type: "LOGOUT" };
}

export function actionUpdateOrg(org: ApiOrg): Action {
  return { type: "UPDATE_ORG", org };
}
